import { useState, type FormEvent } from 'react';

const submitAddr = 'https://readdy.ai/api/form/daej1s1tto0ceqqngu8g';

export default function Subscribe() {
  const [state, setState] = useState<'idle' | 'success' | 'error'>('idle');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    const honeypot = String(fd.get('website_alt') || '').trim();
    if (honeypot) {
      setState('success');
      setMsg('订阅成功！我们会把每日追更速报送达你的邮箱。');
      return;
    }

    fd.delete('website_alt');

    setLoading(true);
    setState('idle');
    try {
      const res = await fetch(submitAddr, { method: 'POST', body: fd });
      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const meta = parsed?.meta as { message?: string; detail?: string } | undefined;
      const code = parsed?.code as string | undefined;
      const serverMsg = meta?.message || meta?.detail || '';
      if (res.ok && code === 'OK' && !/spam/i.test(responseText)) {
        setState('success');
        setMsg('订阅成功！我们会把每日追更速报送达你的邮箱。');
        form.reset();
      } else {
        setState('error');
        setMsg(serverMsg || '订阅失败，请稍后再试，或检查邮箱地址是否正确。');
      }
    } catch {
      setState('error');
      setMsg('网络似乎开小差了，请稍后再试一次。');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="subscribe" className="scroll-mt-20 bg-[#faf6ef] py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="overflow-hidden rounded-3xl bg-gradient-to-br from-[#e85d3f] to-[#c9431f] px-6 py-10 md:px-12 md:py-14">
          <div className="grid items-center gap-8 lg:grid-cols-2">
            <div>
              <p className="mb-2 text-xs font-bold uppercase tracking-widest text-white/80">追更不迷路 · 快人一步</p>
              <h2 className="font-serif-sc text-2xl font-black leading-snug text-white md:text-3xl">
                订阅每日追更速报，
                <br />
                今晚看什么提前知道
              </h2>
              <p className="mt-4 max-w-md text-sm leading-7 text-white/85">
                留下常用邮箱，我们会把今日更新清单与热剧速递直送你的收件箱。不打扰，只在你需要追更的时候出现。
              </p>
            </div>

            <div>
              {state === 'success' ? (
                <div className="rounded-2xl bg-white/95 p-6 text-center">
                  <span className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-[#e85d3f]/10 text-2xl text-[#e85d3f]">
                    <i className="ri-checkbox-circle-line"></i>
                  </span>
                  <p className="text-sm font-bold text-[#26201a]">{msg}</p>
                </div>
              ) : (
                <form
                  data-readdy-form
                  id="subscribe-form"
                  onSubmit={onSubmit}
                  className="rounded-2xl bg-white/95 p-6"
                >
                  <div className="mb-3 flex items-center gap-2 text-[#26201a]">
                    <i className="ri-mail-send-line text-[#e85d3f]"></i>
                    <span className="text-sm font-bold">订阅更新提醒</span>
                  </div>

                  {/* 反垃圾蜜罐字段 */}
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="website_alt_field"
                  />

                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="请输入你的常用邮箱"
                    className="w-full rounded-xl border border-[#26201a]/15 bg-white px-4 py-3 text-sm text-[#26201a] outline-none transition-colors placeholder:text-[#a3988a] focus:border-[#e85d3f]"
                  />

                  {state === 'error' && (
                    <p className="mt-3 flex items-start gap-2 rounded-xl bg-red-50 px-4 py-3 text-xs leading-5 text-red-600">
                      <i className="ri-error-warning-line mt-0.5"></i>
                      {msg}
                    </p>
                  )}

                  <button
                    type="submit"
                    disabled={loading}
                    className="mt-4 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-xl bg-[#26201a] px-5 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-black disabled:cursor-not-allowed disabled:opacity-60"
                  >
                    {loading ? <i className="ri-loader-4-line animate-spin"></i> : <i className="ri-send-plane-line"></i>}
                    {loading ? '提交中…' : '立即订阅每日速报'}
                  </button>
                  <p className="mt-3 text-center text-[11px] text-[#a3988a]">可随时退订，我们绝不发送无关邮件。</p>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}